<template>
  <component :is="structureLayout" class="error_page">
    <p class="fs-4 mb-0 mt-5 text-center">
      {{ trans('common.ERROR.oops') }}
    </p>
    <div
      style="font-family: monospace; max-width: 50vw; transform: rotate(-4deg)"
      class="align-items-center d-flex fs-2 fw-bold justify-content-center lh-1 mb-5 mt-4"
    >
      <span class="text-danger">
        {{ $page.props.statusCode }}
      </span>
      <div class="border-2 border-start border-danger ms-2 ps-2">
        {{ trans('exceptions.' + $page.props.statusCode) }}
      </div>
    </div>
    <p
      class="text-center"
      v-html="trans('exceptions.error_user_links', { errorContactLink: getErrorContactLink($page.props.statusCode) })"
    ></p>
    <p
      v-if="$page.props.user.roles.includes('tech')"
      class="text-center"
      v-html="trans('exceptions.show_backtrace', { target: 'collapseTrace' })"
    ></p>
    <div class="collapse" id="collapseTrace">
      <div class="card card-body bg-white" style="max-height: 16rem; max-width: 50vw; overflow: scroll">
        <div
          v-for="trace in $page.props.trace"
          v-html="trace"
          class="d-flex justify-content-between gap-2 border-bottom"
        ></div>
      </div>
    </div>
  </component>
</template>

<script>
import { ref } from 'vue';
export default {
  props: {
    structure: String,
  },
  setup(props) {
    const getErrorContactLink = (statusCode) =>
      'mailto:ben.haeseler@dataforge.de?subject=' + encodeURIComponent('Error ' + statusCode + ' on ' + window.location.href);
    const structureLayout = ref(null);
    loadStructureLayout(props.structure);

    async function loadStructureLayout(structure) {
      try {
        // Dynamisches Importieren der Datei basierend auf dem Prop-Wert
        const module = await import(`@/structures/${structure}/Pages/Layout`);
        structureLayout.value = module.default || module;
      } catch (error) {
        console.error(`Fehler beim Importieren der Datei: ${error.message}`);
      }
    }

    return {
      getErrorContactLink,
      structureLayout,
    };
  },
};
</script>
